let header = document.querySelector(".header")
let headerBtn = document.querySelector(".header__btnsBurger")

headerBtn.addEventListener("click", () => {
    header.classList.toggle("is-on");
    // if (header.classList.contains("is-on")) {
    //     document.body.style.overflowY = "hidden"
    //     document.documentElement.style.overflowY = "hidden"
    // } else {
    //     document.body.style.overflowY = ""
    //     document.documentElement.style.overflowY = ""
    // }
})